import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class AccessRoleSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector)
    }

    override getIdentifierField(): string {
        return "accessRoleId";
    }
}
